module.exports = __webpack_public_path__ + "static/media/seaOfThieves@2x.5424d724.png";